import React, { useState, useEffect } from 'react';
import { BotIcon, SparklesIcon } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { useAiAssistantStore } from '../../store/useAiAssistantStore';

// Critical modules where the floating FAB should be hidden
const HIDDEN_FAB_PATHS = [
  '/pbx/tools/pbx-cli',
  '/pbx/tools/dashboard',
  '/maintenance/system'
];

export const AiAssistantWidget: React.FC = () => {
  const { toggleChat, isOpen } = useAiAssistantStore();
  const location = useLocation();
  const [isVisible, setIsVisible] = useState(true);

  // Auto-hide logic based on current route
  useEffect(() => {
    const isHiddenPath = HIDDEN_FAB_PATHS.some(path => location.pathname.includes(path));
    setIsVisible(!isHiddenPath);
    
    // Auto-close chat if entering a critical module
    if (isHiddenPath && isOpen) {
      useAiAssistantStore.getState().closeChat();
    }
  }, [location.pathname, isOpen]);

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-20 right-6 z-40">
      <button
        onClick={toggleChat}
        className={`group relative flex items-center justify-center w-14 h-14 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 ease-in-out ${
          isOpen 
            ? 'bg-slate-800 dark:bg-slate-700 text-white rotate-12 scale-95' 
            : 'bg-gradient-to-r from-primary-500 to-indigo-600 text-white hover:scale-105'
        }`}
      >
        <BotIcon size={24} className={`transition-opacity duration-300 ${isOpen ? 'opacity-50' : 'opacity-100'}`} />
        
        {!isOpen && (
          <span className="absolute -top-1 -right-1 flex h-4 w-4">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary-400 opacity-75"></span>
            <span className="relative inline-flex rounded-full h-4 w-4 bg-primary-500 items-center justify-center">
              <SparklesIcon size={10} className="text-white" />
            </span>
          </span>
        )}
      </button>
    </div>
  );
};
